import { addTelemetryMetrics, noop } from '@datadog/browser-core';
export function startInitialViewMetricsTelemetry(lifeCycle, telemetry) {
  if (!telemetry.metricsEnabled) {
    return {
      stop: noop
    };
  }

  var _lifeCycle$subscribe = lifeCycle.subscribe(4
  /* LifeCycleEventType.VIEW_UPDATED */
  , function (_ref) {
    var initialViewMetrics = _ref.initialViewMetrics;

    if (!initialViewMetrics.largestContentfulPaint || !initialViewMetrics.navigationTimings) {
      return;
    } // The navigation timings become available shortly after the load event fires, so
    // we're snapshotting the LCP value available at that point. However, more LCP values
    // can be emitted until the page is scrolled or interacted with, so it's possible that
    // the final LCP value may differ. These metrics are intended to help diagnose
    // performance issues early in the page load process, and using LCP-at-page-load is a
    // good fit for that use case, but it's important to be aware that this is not
    // necessarily equivalent to the normal LCP metric.
    // monitor-until: 2026-07-01


    addTelemetryMetrics("Initial view metrics"
    /* TelemetryMetrics.INITIAL_VIEW_METRICS_TELEMETRY_NAME */
    , {
      metrics: createCoreInitialViewMetrics(initialViewMetrics.largestContentfulPaint, initialViewMetrics.navigationTimings)
    });
    unsubscribe();
  }),
      unsubscribe = _lifeCycle$subscribe.unsubscribe;

  return {
    stop: unsubscribe
  };
}

function createCoreInitialViewMetrics(lcp, navigation) {
  return {
    lcp: {
      value: lcp.value
    },
    navigation: {
      domComplete: navigation.domComplete,
      domContentLoaded: navigation.domContentLoaded,
      domInteractive: navigation.domInteractive,
      firstByte: navigation.firstByte,
      loadEvent: navigation.loadEvent
    }
  };
}